// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"320":"views-dashboard","957":"views-app"}[chunkId] || chunkId) + "." + {"269":"6b3d611d","320":"69c70782","885":"0f1d80ce","957":"6311f161"}[chunkId] + ".chunk.css";
};